import { useTranslation } from 'react-i18next';
import { RESERVABLE_TIME_UNIT_IN_MINUTES, SPACE_TYPE } from '@/constants/space';
import { useDateTimeFormat } from '@/hooks/useDateTimeFormat';

interface ReservationIntroProps {
  selectedTime: string;
}

/**
 * 予約イントロセクションコンポーネント
 */
export const ReservationIntro = ({ selectedTime }: ReservationIntroProps) => {
  const { t } = useTranslation();
  const { formatReservationTimeWithDuration } = useDateTimeFormat();

  return (
    <div className="f3__intro">
      <div className="f3__intro-text">
        {t('shareDevice.userInfo.introText1')}
        <br />
        {t('shareDevice.userInfo.introText2')}
      </div>
      <div className="f3__time">
        {t('shareDevice.userInfo.reservationTime')}
        {formatReservationTimeWithDuration(
          selectedTime,
          RESERVABLE_TIME_UNIT_IN_MINUTES[SPACE_TYPE.SHOWER_ROOM],
        )}
      </div>
    </div>
  );
};
